import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceTableStore } from '@y42/datasource';
import { UiModelingTableGitFactoryService } from './ui-modeling-table-git-factory.service';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ui-modeling-table', idKey: '$path' })
export class UiModelingTableStore extends DatasourceTableStore {
  constructor(protected readonly gitFactory: UiModelingTableGitFactoryService) {
    super('UI-Modeling-Table', gitFactory);
  }
}
